module.exports = __webpack_public_path__ + "static/img/15.8f42351.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carrusel/15.png
// module id = iHRO
// module chunks = 5